import { computed } from 'vue'

export default {
    name: 'ProductCard',
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {}
    }
}
